import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

// RxJs
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


// services
import { SecurityService } from '@app/core/security/service/security.service';
import { BrowserDetectionService } from '../browser-detection/browser-detection.service';
import { ContextService } from '../context/context.service';


@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  
  constructor(
    private readonly injector: Injector,
    private readonly browserDetectionService: BrowserDetectionService
  ) { }
  
  

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.params.get('noHeader')) {
      const params = req.params.delete('noHeader');
      const aux = req.clone({params});
      return next.handle(aux);
    }

    const token = this.injector.get(SecurityService).token;
    console.log({ header: token });
    const tenant = this.injector.get(ContextService).country;
    let headers = req.headers
    // .set('Content-Type', 'application/json')
    .set('Authorization', 'Bearer ' + token)

    // Headers de seguridad
    .set('X-Content-Type-Options', 'nosniff')
    .set('X-XSS-Protection', '1; mode=block')
    .set('X-Frame-Options', 'SAMEORIGIN')
    .set('Strict-Transport-Security', 'max-age=31536000');
    // End headers de seguridad

    // if (tenant) {
    headers = headers.set('x-tenant-id', tenant || 'option');
    // }
    if (this.browserDetectionService.isIE) {
      headers = headers
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache');
    }
    const authReq = req.clone({headers});
    console.log({authReq});
    return next.handle(authReq).pipe(
      catchError(err => {
        if ([401, 403].includes(err.status)) { this.injector.get(SecurityService).logOut(); }
        
        return throwError(err);
      })
    );
  }
}
